import { useEffect, useRef, useState } from 'react';

import { useGetMyRestProfile } from '@/api/rest/users/useGetMyRestProfile';

export function usePrevious(value: any) {
  const ref = useRef(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const useHashFragment = (hash: string): [boolean, () => void] => {
  const [isActive, setIsActive] = useState(location.hash === hash);

  useEffect(() => {
    setIsActive(location.hash === hash);
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has an unnecessary dependency: location.
  }, [location.hash, hash]);

  const toggleHashFragment = isActive
    ? () => {
        location.hash = '';
      }
    : () => {
        location.hash = hash;
      };

  return [isActive, toggleHashFragment];
};

export function useIsPayacaAdmin(): boolean {
  const { data } = useGetMyRestProfile();
  return data?.isPayacaAdmin ?? false;
}
